import React from "react";
import { connect } from "react-redux";
import {Button,CssBaseline,TextField,
  Link,Grid, Divider,Paper,Typography,Container,Radio,RadioGroup,FormControlLabel
  ,FormControl,FormLabel,withStyles
} from "@material-ui/core";
import { history } from "../components/helpers/History";
import { UserActions } from "../redux/actions/UserActions";
import { Formik } from "formik";
import * as Yup from "yup";
import Logo from "../components/logo/HomeLogo";
import ForgetPwdSecretQuestion from "./ForgetPwdSecretQuestion";
import ForgetPwdSMS from "./ForgetPwdSMS";
import UpdatePassword from "./UpdatePassword";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(6),
  },
  avatar: {
    margin: theme.spacing(3),
  },
  typography: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  resetOptions: {
    marginTop: theme.spacing(5),
  }
});

class ForgetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailValidated: false,
      email: "",
      isSecretQuesValidated: false,
      isOTPvalidated: false,
      isPasswordUpdated: false,
      isSecretQuestionChoosed: false,
      isSmsChoosed: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isEmailValidated !== this.state.isEmailValidated) {
      this.setState({ isEmailValidated: this.props.isEmailValidated });
    }
    if (this.props.isSecretQuesValidated !== this.state.isSecretQuesValidated) {
      this.setState({
        isSecretQuesValidated: this.props.isSecretQuesValidated,
      });
    }
    if (this.props.isOTPvalidated !== this.state.isOTPvalidated) {
      this.setState({
        isOTPvalidated: this.props.isOTPvalidated,
      });
    }
    if (this.props.isPasswordUpdated !== this.state.isPasswordUpdated) {
      history.push("/login");
    }
  }

  render() {
    const classes = this.props.classes;
    return (
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Paper className={classes.paper}>
          <Logo></Logo>

          {(this.state.isSecretQuesValidated || this.state.isOTPvalidated)? (
            <>
              <UpdatePassword userId={this.props.id} />
            </>
          ) : this.state.isEmailValidated ? (
            <>
              {!(this.state.isSecretQuestionChoosed || this.state.isSmsChoosed) ? (
                <>
                <FormControl component="fieldset" className={classes.resetOptions}>
                  <FormLabel component="legend">Please use any one of the below options to reset password</FormLabel>
                  <RadioGroup aria-label="resetPwdOptions" name="resetPwdOptions" onChange={(e)=>{
                    let value = e.target.value;
                    if(value === 'sms'){
                      this.setState({isSmsChoosed:true});
                      this.setState({isSecretQuestionChoosed:false});
                    }else if(value === 'secret question'){
                      this.setState({isSecretQuestionChoosed:true});
                      this.setState({isSmsChoosed:false});
                    }
                    
                  }}>
                    {this.props.secretQuestion &&
                this.props.secretQuestion.length > 0?
                    <FormControlLabel value="secret question" control={<Radio />} label="Answer authentication questions" />
                  :null}
                    <FormControlLabel value="sms" control={<Radio />} label="Receive authorization code by SMS" />
                </RadioGroup>
              </FormControl>
                  <div className={classes.buttons}>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={()=>{history.push("/login");}}
                      >
                        Login
                      </Button>
                    </div>
              </>
              ) : this.state.isSecretQuestionChoosed ? (
                this.props.secretQuestion &&
                this.props.secretQuestion.length > 0 ? (
                  <ForgetPwdSecretQuestion
                    username={this.state.email}
                    question1={this.props.secretQuestion[0]}
                    question2={this.props.secretQuestion[1]}
                    question3={this.props.secretQuestion[2]}
                    handleBack={()=>{this.setState({isSecretQuestionChoosed:false});}}
                  />
                ) : (
                  <Typography
                    component="h1"
                    variant="h5"
                    className={classes.typography}
                  >
                    Please reach to doctor hospital to reset your password
                  </Typography>
                )
              ) : this.state.isSmsChoosed ? 
                 <ForgetPwdSMS
                    username={this.state.email}
                    handleBack={()=>{this.setState({isSmsChoosed:false});}}                    
                  />
               : (
                <Typography
                  component="h1"
                  variant="h5"
                  className={classes.typography}
                >
                  Please reach to doctor hospital to reset your password
                </Typography>
              )}
            </>
          ) : (
            <>
              <Typography
                component="h1"
                variant="h5"
                align="left"
                className={classes.typography}
              >
                Forget password
              </Typography>

              <Formik
                initialValues={{
                  email: "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .email("Must be a valid email")
                    .max(100)
                    .required("Email is required"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({ email: values.email });
                  this.props.validateEmail(values.email);
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  touched,
                  values,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    className={classes.form}
                    noValidate
                    name="form"
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          error={Boolean(touched.email && errors.email)}
                          fullWidth
                          helperText={touched.email && errors.email}
                          label="Email | Username"
                          name="email"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            this.setState({ submitted: false });
                            handleChange(e);
                          }}
                          value={values.email}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    <div className={classes.buttons}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        disabled={this.state.submitted}
                      >
                        Verify
                      </Button>
                    </div>
                    <Divider variant="middle" className={classes.divider} />
                    <Grid container justify="center">
                      <Grid item>
                        <Link href="/login" variant="body2">
                          Login
                        </Link>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          )}
        </Paper>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  const isOTPvalidated = state.authentication.isOTPvalidated;
  const isEmailValidated = state.authentication.isEmailValidated;
  const isSecretQuesValidated = state.authentication.isSecretQuesValidated;
  const isPasswordUpdated = state.authentication.isPasswordUpdated;
  const secretQuestion = state.authentication.secretQuestion;
  const id = state.authentication.id;

  return {
    isEmailValidated,
    secretQuestion,
    id,
    isSecretQuesValidated,
    isPasswordUpdated,
    isOTPvalidated,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    validateEmail: (email) => {
      dispatch(UserActions.validateEmail(email));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(ForgetPassword));

